import React, { useEffect, useState, useRef } from 'react'
import DatePicker from "react-datepicker";
import { Checkbox, FormControlLabel } from '@mui/material';
import useManageOrder from '../../order/useManageOrder';
import { toast } from 'react-toastify';
import useGetCustomerProfile from '../../../hooks/useGetCustomerProfile';
import Modal from 'react-modal';
import AddEditForm from '../../../sharedComponents/AddEditForm';
import useCustomerProfile from '../../customerProfile/useCustomerProfile';

const initialValue = {
  smileNameInput: '',
  trackingJp: '',
  contact:'',
  phone:'',
  orderDate: new Date(),
  isHandCarry: false
}

const items = [
  {
    title: 'ชื่อ - นามสกุล',
    name: 'name',
    type: 'text',
  },
  {
    title: 'เบอร์โทรศัพท์',
    name: 'phone',
    type: 'text',
  },
  {
    title: 'ช่องทางการติดต่อ (Line, Facebook)',
    name: 'channel',
    type: 'select',
    options:[{
      label: 'Facebook',
      value: 'Facebook'
    },{
      label: 'Line',
      value: 'Line'
    }]
  },
  {
    title: 'ชื่อ Line/Facebook',
    name: 'contact',
    type: 'text',
  },
  {
    title: 'ประเภทสินค้าที่ฝากส่ง',
    name: 'note',
    type: 'text',
  },
  
];

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)' // This sets the overlay color
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '500px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const initialProfile = {
  smileNameJp : '',
  channel : ''
}

const SendOnlyForm = () => {

  const [order, setOrder] = useState(initialValue)
  const {profile, getProfileFromPhone}= useGetCustomerProfile()
  const {addCustomerProfile, isLoading: isCustomerProfileLoading} = useCustomerProfile()
  const [newProfile, setNewProfile] = useState(initialProfile)
  const [registerIsOpen, setRegisterIsOpen] = useState(false)
  const registerSubmittingRef = useRef(false)
  const {error, addSendOnlyNewOrder} = useManageOrder()

  const handleInputChange = (e) => {
    const {name, value, type, checked} = e.target
    setOrder(prevOrder => ({
      ...prevOrder,
      [name]: type === 'checkbox' ? checked : value
     }));
     console.log(order)
  }

  const handleDateChange = (name, selectedDate) => {
    setOrder(prevOrder => ({
        ...prevOrder,
        [name]: selectedDate
    }));
	};

  const closeRegisterForm = () => {
    setRegisterIsOpen(false)
  }

  const openRegisterForm = () => {
    setRegisterIsOpen(true)
  }

  const handleRegisterCustomerProfile = async () => {
    if (registerSubmittingRef.current) return
    registerSubmittingRef.current = true
    try {
      const profileWithSendOnly = {
        ...newProfile,
        sendOnly: true,
      }
      const registerdResult = await addCustomerProfile(profileWithSendOnly)
      if(registerdResult === true){
      setOrder(prevOrder => ({
        ...prevOrder,
        phone : newProfile.phone,
        contact : newProfile.contact
      }));
      toast.success("ลงทะเบียนสำเร็จ")
      setRegisterIsOpen(false)
    }else{
      if(registerdResult === 'Smile Name Duplicate'){
        toast.error('ชื่อ สมาย ซ้ำกับคนอื่น')
      }else{
        toast.error(registerdResult)
      }
    }
    } finally {
      registerSubmittingRef.current = false
    }
  }

  const handleNewProfileChange = (e) => {
    const {name, value} = e.target
    setNewProfile(prevState => ({
        ...prevState,
        [name]: value
    }));
  };

  const handleCheckPhone = async () => {
    const trimmedPhone = order.phone.replace(/\D/g, "");
    const result = await getProfileFromPhone(trimmedPhone)
    if(!result){
      toast.info("ไม่พบข้อมูลเบอร์โทร ที่ค้นหา")
    }
  }

  useEffect(() => {
    if(profile){
      setOrder(prevOrder => ({
        ...prevOrder,
        contact: profile.contact
      }));
    }
  },[profile])

  const handleSubmit = async (e) => {
    e.preventDefault()
    const result = await addSendOnlyNewOrder(order)
    if(result){
      toast.success("Successfully add new Order")
      setOrder(initialValue)
    }else{
      toast.error(error)
    }
  }

  useEffect(() => {
    toast.error(error)
  }, [error]);

  return (
    <div className='mx-auto mt-5 mx-10 md:container'>
      <form>
        <Modal
          isOpen={registerIsOpen}
          onRequestClose={closeRegisterForm}
          style={customStyles}
          ariaHideApp={false}
          >
          <AddEditForm 
            items={items} 
            name='ลงทะเบียนลูกค้าใหม่' 
            mode='register'
            closeForm={closeRegisterForm}
            data={newProfile}
            handleInputChange={handleNewProfileChange}
            handleRegister={handleRegisterCustomerProfile}
            stateValue={newProfile}
            submitting={isCustomerProfileLoading}
            />
        </Modal>
        <div className="space-y-12 sm:space-y-16">
          <div className=''>
            <h2 className="text-3xl font-semibold leading-7 text-gray-900">รายการฝากส่ง SMILE</h2>
            <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-600">
              <span className="">ที่อยู่ที่ใช้ในการสั่งของมาลงที่โกดัง</span><br/>
              <span className="">ชื่อ : SMILE (...ตามด้วยชื่อลูกค้า...)</span><br/>
              <span className="">ที่อยู่ : 340-0036,</span><br/>
              <span className="">Saitama Ken, Soka Shi, Naetsuka Cho, 452-1</span><br/>
              <span className="">เบอร์ : 080-7794-0424</span><br/>
              <span className="">***จำเป็นต้องใส่ SMILE ทุกครั้ง</span><br/>
              <span className="">------------------------------------------------</span><br/>
              <span className="">〒340-0036</span><br/>
              <span className="">埼玉県 草加市 苗塚町 452-1</span><br/>
              <span className="">080-7794-0424</span>
            </p>
            <button
              type='button'
              onClick={openRegisterForm}
              className="mt-3 w-60 rounded-md bg-green-600 px-10 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
              >
              ลงทะเบียนลูกค้าใหม่
            </button>
          </div>

          <div>
            <div className="mt-10 space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
              <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                <label htmlFor="phone" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  เบอร์โทรศัพท์ (Phone No.) <span className='text-red-500'>*ใช้สำหรับเช็คสถานะพัสดุ</span>
                </label>
                <div className="mt-2 sm:col-span-1 sm:mt-0">
                  <input
                    id="phone"
                    name="phone"
                    type="text"
                    value={order?.phone}
                    onChange={handleInputChange}
                    className="input-form w-full"
                    />
                  <button
                    type="button"
                    onClick={handleCheckPhone}
                    className="inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >Check</button>
                </div>
              </div>
              <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                <label htmlFor="contact" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  Line / Facebook
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <input
                    type="text"
                    name="contact"
                    id="contact"
                    value={order?.contact}
                    onChange={handleInputChange}
                    className="input-form bg-gray-200 w-full" 
                    readOnly
                    />
                </div>
              </div>


              <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                <label htmlFor="smileNameInput" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  ชื่อหน้ากล่อง (SMILE .....)
                </label>
                <div className="mt-2 col-span-1 sm:mt-0">
                  <input
                    type="text"
                    name="smileNameInput"
                    id="smileNameInput"
                    value={order?.smileNameInput}
                    onChange={handleInputChange}
                    className="input-form w-full"
                    />
                </div>
              </div>

              <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                <label htmlFor="orderDate" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                    วันที่สั่งของ (Order Date)
                </label>
                <div className="mt-2 sm:col-span-1 sm:mt-0">
                  <DatePicker 
                    selected={order.orderDate}
                    onChange={(date) => handleDateChange("orderDate", date)}
                    dateFormat={"yyyy-MM-dd"}
                    className='datepicker w-full'
                    />
                </div>
              </div>

              <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                <label htmlFor="trackingJp" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  เลขพัสดุญี่ปุ่น (Japan Tracking)
                </label>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <input
                    type="text"
                    name="trackingJp"
                    id="trackingJp"
                    value={order.trackingJp}
                    onChange={handleInputChange}
                    className="input-form w-full"
                    />
                  <div className='text-red-600'>กรอกเฉพาะตัวเลข ไม่ต้องระบุขนส่ง</div>
                  <div className='text-red-600'>(1 เลขต่อการกรอก 1 ครั้ง)</div>
                </div>
              </div>

              <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
                <div className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                  ประเภทการส่ง
                </div>
                <div className="mt-2 sm:col-span-2 sm:mt-0">
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isHandCarry"
                        checked={order.isHandCarry}
                        onChange={handleInputChange}
                        color="primary"
                      />
                    }
                    label="เป็น รายการหิ้วทางเครื่องบิน"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 flex items-center justify-end gap-x-6">
          <button
            type="submit"
            onClick={handleSubmit}
            className="inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
            Save
          </button>
        </div>
      </form>
    </div>
  )
}

export default SendOnlyForm